<template>
  <bimRow class="block-opportunities py-12 d-flex flex-column">
    <bim-text class="block-opportunities__title pb-12" type=h5 bold>Два шага до новых возможностей:</bim-text>

    <bimRow class="opportunities flex-column">
      <bimCol class="opportunities-item d-flex mb-10">
        <img src="/dist/assets/front_white/img/landing_gisp/group-3.svg" alt="" class="opportunities-item__image" />
        <div class="opportunities-item__text-wrapper d-flex flex-column justify-center">
          <bim-text type="accent" bold class="opportunities-item__text-title pb-6">
            Подключите сервис BIMLIB в личном кабинете ГИСП
          </bim-text>
          <bim-text type="main" class="opportunities-item__text-desc">
            Сервис доступен бесплатно всем зарегистрированным пользователям платформы.
          </bim-text>
        </div>
      </bimCol>

      <bimCol class="opportunities-item d-flex">
        <img src="/dist/assets/front_white/img/landing_gisp/img-landing-gisp-5.svg" alt="" class="opportunities-item__image" />
        <div class="opportunities-item__text-wrapper d-flex flex-column justify-center">
          <bim-text type="accent" bold class="opportunities-item__text-title pb-6">
            Создайте цифровой паспорт вашей продукции
          </bim-text>
          <bim-text type="main" class="opportunities-item__text-desc">
            На основе уже заполненного каталога по ПП1604, заполните цифровые паспорта продукции свойствами, НТД и сертификатами.
          </bim-text>
        </div>
      </bimCol>
    </bimRow>

    <bimCol class="mt-11 d-flex justify-center">
      <ButtonTryService />
    </bimCol>
  </bimRow>
</template>

<script>
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"

import ButtonTryService from "./ButtonTryService"
export default {
  name: "BlockNewOpportunities",
  components: {
    bimRow,
    bimCol,

    ButtonTryService
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/grid-settings";

.block-opportunities {

  .block-opportunities__title {
    width: 100%;
    text-align: center;
    line-height: 1.13;
  }
}

.opportunities {

  .opportunities-item {
    max-width: 800px;
    margin: auto;
    padding: 45px 31px;
    border-radius: 9px;
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.05);
  }

  .opportunities-item__image {
    margin-right: 50px;
  }

  .opportunities-item__text-title {
    line-height: 1.29;
  }
  .opportunities-item__text-desc {
    line-height: 1.5;
    letter-spacing: 0.2px;
  }

  @media screen and (max-width: $breakpoint-sm) {
    .opportunities-item {
      flex-direction: column;
    }

    .opportunities-item__image {
      padding-bottom: 24px;
    }
  }
}
</style>
